export default __webpack_public_path__ + "static/media/upload@2x.0d3bb2a3.png";